// Copyright (c) 2016 Deere & Company

import Customer, {getDefaultState as getCustomerDefaultState} from './customer';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import RegistrationProduct, {getDefaultState as getRegistrationProductDefaultState} from './registration-product';
import UseAmount, {getDefaultState as getUseAmountDefaultState} from './use-amount';
import RegistrationError from './registration-error';
import t from 'tcomb';

const Registration = t.struct({
    comments: t.String,
    creationDate: t.maybe(t.Number),
    customer: Customer,
    deliveryDate: t.maybe(t.Number),
    endUseCode: KeyValuePair,
    errors: t.list(RegistrationError),
    firstUseDate: t.maybe(t.Number),
    id: t.String,
    language: t.String,
    licensePlate: t.String,
    operatorManualNumber: t.String,
    otherUseAmount: t.maybe(UseAmount),
    product: RegistrationProduct,
    purchaserType: KeyValuePair,
    registrationDate: t.maybe(t.Number),
    responsibleDealer: Dealer,
    status: t.String,
    statusIndicator: KeyValuePair,
    useAmount: UseAmount
}, {
    name: 'Registration',
    strict: true
});

export const getDefaultState = () => new Registration({
    comments: '',
    creationDate: null,
    customer: getCustomerDefaultState(),
    deliveryDate: null,
    endUseCode: getKeyValueDefaultState(),
    errors: [],
    firstUseDate: null,
    id: '',
    language: '',
    licensePlate: '',
    operatorManualNumber: '',
    otherUseAmount: getUseAmountDefaultState(),
    product: getRegistrationProductDefaultState(),
    purchaserType: getKeyValueDefaultState(),
    registrationDate: null,
    responsibleDealer: getDealerDefaultState(),
    status: '',
    statusIndicator: getKeyValueDefaultState(),
    useAmount: getUseAmountDefaultState()
});

export default Registration;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/registration.js